export default __webpack_public_path__ + "media/content-vector.068b5fd08e4babd76bba5d2a23e52409.svg";